import { Box } from '@mui/material';
import styled from 'styled-components';

export const PointsBox = styled(Box)`
  background-color: ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.primary.contrastText};
`;
